import { c as _c } from "react/compiler-runtime";
import { FunnelStorageSDK } from "@website/tracking/storage";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { useEffect } from "react";
import type { ChatbotSource, ChatbotTrackingEvent } from "./types";
const isUserTrackingEvent = (event: string): event is USER_TRACKING_EVENTS => Object.values(USER_TRACKING_EVENTS).includes(event as USER_TRACKING_EVENTS);
const RESET_FUNNEL_EVENTS = new Set<USER_TRACKING_EVENTS>([USER_TRACKING_EVENTS.CHATBOT_PRODUCT_SELECTED]);
const CHATBOT_FUNNEL_FIELDS = ["product_type", "vertical", "intent", "tracking_code", "route", "trip_type", "cancellation_reason", "cancellation_type", "feedback_score"];
const shouldResetChatbotFunnel = (event: USER_TRACKING_EVENTS) => RESET_FUNNEL_EVENTS.has(event);
export const trackChatbotEvent = (tracking?: ChatbotTrackingEvent) => {
  if (!tracking || !isUserTrackingEvent(tracking.event)) return;
  const product = tracking.product ?? "core";
  if (shouldResetChatbotFunnel(tracking.event)) {
    FunnelStorageSDK.removeFunnelFields(product, CHATBOT_FUNNEL_FIELDS);
  }
  FunnelStorageSDK.addEventToTrackingFunnel(tracking.event, product, tracking.attributes as never);
};
export const useTrackChatbotView = tracking => {
  const $ = _c(3);
  let t0;
  if ($[0] !== tracking) {
    t0 = () => {
      if (!tracking) {
        return;
      }
      trackChatbotEvent(tracking);
    };
    $[0] = tracking;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export const trackChatbotIconClicked = (source: ChatbotSource) => {
  FunnelStorageSDK.addEventToTrackingFunnel(USER_TRACKING_EVENTS.CHATBOT_ICON_CLICKED, "core", {
    chatbot_source: source
  });
};
export const trackLoginModalDisplayed = () => {
  FunnelStorageSDK.addEventToTrackingFunnel(USER_TRACKING_EVENTS.CHATBOT_LOGIN_MODAL_DISPLAYED, "core");
};
export const trackLoginModalCompleted = () => {
  FunnelStorageSDK.addEventToTrackingFunnel(USER_TRACKING_EVENTS.CHATBOT_LOGIN_COMPLETED, "core");
};
export const trackFeedbackSubmitted = (rate: string) => {
  FunnelStorageSDK.addEventToTrackingFunnel(USER_TRACKING_EVENTS.CHATBOT_FEEDBACK_SUBMITTED, "core", {
    feedback_score: Number(rate) || 0
  });
};